interface LocalStorage {
  setItem: (key: string, value: object, ttl: number) => void;
  getItem: <T>(key: string, compare: (cached: T) => boolean) => T | undefined;
}

export const localStorageClient: LocalStorage = {
  setItem: (key: string, value: object, ttl: number): void => {
    localStorage.setItem(
      key,
      JSON.stringify({
        ...value,
        expireAt: new Date(new Date().getTime() + ttl).toISOString(),
      }),
    );
  },

  getItem: <T>(key: string, compare: (cached: T) => boolean): T | undefined => {
    try {
      const data = localStorage.getItem(key);

      if (data != null) {
        const cached = JSON.parse(data);
        if (new Date(cached.expireAt) > new Date() && compare(cached))
          return cached;
      }
    } catch (e) {}
    return undefined;
  },
};
